import angular from 'angular';
import serviceOrdersComponent from './service-orders.component';
import serviceOrdersService from './service-orders.service';
import serviceOrdersConfig from './service-orders.config';

let serviceOrdersModule = angular.module('app.serviceOrders',[])
  .component('serviceOrders', serviceOrdersComponent)
  .service('ServiceOrdersService', serviceOrdersService)
  .config(serviceOrdersConfig);

export default serviceOrdersModule;



// WEBPACK FOOTER //
// ./www/components/payments-advances/service-orders/service-orders.js